import { Button, Form, Modal, Input, Select, message } from 'antd';
import { useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { useAppDispatch } from '../../methods/redux/hooks';
import {
	deleteLocalSwapRate,
	editLocalSwapRate,
} from '../../methods/redux/reducers/swap';
import NativeNumber from '../../component/Numeral';

interface ISwapProtocolItem {
	data: any;
	setRefresh: Function;
	currencySelect: any;
}

const Styles = styled.div`
	display: flex;
	justify-content: space-between;
	background-color: #f8f8f8;
	padding: 20px;
	margin-bottom: 5px;

	& .label {
		font-size: 13px;
		color: #808080;
		font-style: italic;
	}
`;

export const StyledFormItem = styled(Form.Item)`
	.ant-row {
		display: block;
	}
`;

const LocalSwapRateItem = ({
	data,
	setRefresh,
	currencySelect,
}: ISwapProtocolItem) => {
	const dispatch = useAppDispatch();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
	};

	const deleteSwapRate = async () => {
		try {
			setLoading(true);
			await dispatch(deleteLocalSwapRate(data?._id));
			setRefresh(Math.random());
		} catch (error: any) {
			message.error(error?.response?.message);
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);
			const jobData = {
				baseCurrencyId: values.baseCurrencyId,
				quoteCurrencyId: values.quoteCurrencyId,
				rate: values.rate,
				volume: values.volume,
			};
			await dispatch(editLocalSwapRate({ id: data?._id, data: jobData }));
			handleCancel();
			form.resetFields();
			setRefresh(Math.random());
		} catch (error: any) {
			message.error(error?.response?.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Styles>
			<div>
				<p>{data?.baseCurrencyId?.symbol}</p>
				<p className="label">Base Currency</p>
			</div>
			<div>
				<p>{data?.quoteCurrencyId?.symbol}</p>
				<p className="label">Quote Currency</p>
			</div>
			<div>
				<p>
					<NativeNumber value={data?.rate} />
				</p>
				<p className="label">Rate</p>
			</div>
			<div>
				<p>
					<NativeNumber value={data?.volume} />
				</p>
				<p className="label">Volume</p>
			</div>
			<div>
				<p>{moment(data.createdAt).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Created At</p>
			</div>
			<div>
				<p>{moment(data.updatedAt).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Updated At</p>
			</div>
			<div style={{ display: 'flex', gap: '4px' }}>
				<Button type="default" size="small" onClick={showModal}>
					Edit
				</Button>
				<Button danger size="small" onClick={deleteSwapRate} loading={loading}>
					Delete
				</Button>
			</div>

			{/* Modal for Creating a Swap Rate */}
			<Modal
				title="Edit Swap Rate"
				visible={isModalVisible}
				onCancel={handleCancel}
				footer={null}
			>
				<Form form={form} onFinish={handleSubmit}>
					<StyledFormItem
						name="baseCurrencyId"
						label="Base Currency"
						initialValue={data?.baseCurrencyId?._id}
						rules={[
							{ required: true, message: 'Please input the base currency!' },
						]}
					>
						<Select style={{ width: '100%' }} placeholder="Select a currency">
							{currencySelect?.length > 0 &&
								currencySelect?.map((currency: any) => (
									<Select.Option value={currency.value} key={currency.value}>
										{currency.name}
									</Select.Option>
								))}
						</Select>
					</StyledFormItem>

					<StyledFormItem
						name="quoteCurrencyId"
						label="Quote Currency"
						initialValue={data?.quoteCurrencyId?._id}
						rules={[
							{ required: true, message: 'Please input the quote currency!' },
						]}
					>
						<Select style={{ width: '100%' }} placeholder="Select a currency">
							{currencySelect?.length > 0 &&
								currencySelect?.map((currency: any) => (
									<Select.Option value={currency.value} key={currency.value}>
										{currency.name}
									</Select.Option>
								))}
						</Select>
					</StyledFormItem>

					<StyledFormItem
						name="rate"
						label="Rate (Amount of Quote that equal to 1 Base Currency)"
						initialValue={data?.rate}
						rules={[{ required: true, message: 'Please input the rate!' }]}
					>
						<Input placeholder="e.g., 1.25" />
					</StyledFormItem>

					<StyledFormItem
						name="volume"
						label="Volume"
						initialValue={data?.volume}
						rules={[{ required: true, message: 'Please input volume!' }]}
					>
						<Input placeholder="e.g., 1000" />
					</StyledFormItem>
					<Form.Item>
						<Button type="primary" htmlType="submit" loading={loading}>
							{loading ? 'Editing...' : 'Edit Swap Rate'}
						</Button>
						<Button onClick={handleCancel} style={{ marginLeft: '8px' }}>
							Cancel
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</Styles>
	);
};

export default LocalSwapRateItem;
